<template>
  <div class="sequence-accueil">
    <h2 class="subtitle">Options du site internet</h2>
    <hr />
    <violet-bar>Sélection de projets</violet-bar>
    <div class="box squarebox">
      <div style="display: flex; width: 100%">
        <div class="column is-half">
          <h3 class="title is-5" style="margin-bottom: 1.75em;">
            Projets disponibles
          </h3>
          <div class="available-projects columns is-multiline">
            <div
              v-for="project in availableProjects"
              :key="project.id"
              class="project-item column is-one-third"
              style="font-size: 9px; padding: 4px;"
              @click="addToList(project.id)"
            >
              <div class="squarebox">
                {{ project.web_title || project.name }}<br />
                {{ project.web_description }}
                <api-picture
                  :pictureId="project.web_image || project.main_image"
                  :small="true"
                ></api-picture>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-half">
          <h3 class="title is-5">Projets sélectionnés</h3>
          <vue-draggable
            :value="selectedIds"
            @input="selectedIds = $event"
            style="display: flex; flex-wrap: wrap; justify-content: space-between;"
            :handle="'.handle'"
          >
            <div
              v-for="projectId in selectedIds"
              :key="projectId"
              class="project-item"
              style="font-size: 9px; padding: 4px; flex: 0 0 33%;"
            >
              <div
                class="squarebox is-relative"
                style="padding-top: 1.5em;"
                v-if="projectsMap[projectId]"
              >
                <span
                  class="handle"
                  style="display: block; position: absolute; left:0.25em; top: 0.25em;"
                  >☰</span
                >
                {{
                  projectsMap[projectId].web_title ||
                    projectsMap[projectId].name
                }}<br />
                {{ projectsMap[projectId].web_description }}
                <api-picture
                  :pictureId="
                    projectsMap[projectId].web_image ||
                      projectsMap[projectId].main_image
                  "
                  :small="true"
                ></api-picture>
                <button
                  class="delete is-small"
                  style="position: absolute; top:0.25em; right: 0.25em;"
                  @click="removeFromList(projectId)"
                ></button>
              </div>
            </div>
          </vue-draggable>
        </div>
      </div>
    </div>
    <div class="buttons">
      <button class="button is-primary" @click="this.save">Enregistrer</button>
    </div>
  </div>
</template>
<script>
import VioletBar from "../Projects/VioletBar";
import ApiPicture from "./../../components/Form/ApiPicture.vue";
import VueDraggable from "vuedraggable";
import { types } from "../../store/actions/misc";
import { types as projectTypes } from "../../store/actions/projects";

const defaultList = () => [];

export default {
  name: "sequence_accueil",
  components: { VioletBar, VueDraggable, ApiPicture },
  data() {
    return {
      selectedIds: [],
      projects: []
    };
  },
  computed: {
    projectsMap() {
      return this.projects.reduce((acc, project) => {
        acc[project.id] = project;
        return acc;
      }, {});
    },
    availableProjects() {
      return this.projects.filter(p => !this.selectedIds.includes(p.id));
    }
  },
  methods: {
    removeFromList(projectId) {
      this.selectedIds = this.selectedIds.filter(id => id !== projectId);
    },
    addToList(projectId) {
      this.selectedIds = [projectId, ...this.selectedIds];
    },
    async fetch() {
      try {
        this.$set(
          this,
          "selectedIds",
          await this.$store.dispatch(types.GET_PROJECT_SELECTION)
        );
        if (
          this.selectedIds.length &&
          typeof this.selectedIds[0] !== "number"
        ) {
          this.$set(this, "selectedIds", defaultList());
        }
      } catch (e) {
        this.$set(this, "selectedIds", defaultList());
      }
      this.$set(
        this,
        "projects",
        await this.$store.dispatch(projectTypes.GET_PROJECTS)
      );

      // Clean up non-existent projects from the list
      if (this.selectedIds.length && this.projects.length) {
        this.selectedIds = this.selectedIds.filter(id => this.projectsMap[id]);
      }
    },
    async save() {
      await this.$store.dispatch(types.SET_PROJECT_SELECTION, this.selectedIds);
      await this.fetch();
    }
  },
  mounted() {
    this.fetch();
  }
};
</script>
